export default __webpack_public_path__ + "static/media/fish-lqMAX.jpg.f69a998e.txt";